import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

const SLUG = publicRuntimeConfig?.INSTITUTION_SLUG

const INSTITUTIONS_CLIENTS = ['igesdf', 'agsus', 'inovasuas', 'sebrae', 'uff']
const CITIZENS_CLIENTS = ['fala']
const DIGITAL_CEP_CLIENTS = ['brasil', 'mocambique']

const DOMAIN = INSTITUTIONS_CLIENTS.includes(SLUG)
  ? 'instituicao.me'
  : CITIZENS_CLIENTS.includes(SLUG)
    ? 'cidadao.me'
    : DIGITAL_CEP_CLIENTS.includes(SLUG) ? 'cepdigital.org.br' : 'prefeitura.me'

//WEBSITES
export const SOCIALME_WEBSITE = 'http://socialme.com.br'
export const REDIRECTOR_URL = 'https://prftr.me'
export const ROOT_URL = `https://${SLUG}.${DOMAIN}`
//MODULES
export const UNIFIED_LOGIN_URL = `https://${SLUG}.${DOMAIN}/login-unificado`
export const APP_CITIZEN_URL = `https://${SLUG}.${DOMAIN}/app-cidadao`
export const INSTITUTIONAL_MANAGEMENT_URL = `https://${SLUG}.${DOMAIN}/gestao-institucional`
export const ALERTS_OF_VULNERABILITY_URL = `https://${SLUG}.${DOMAIN}/alertas-de-vulnerabilidade`
export const CITIZEN_PORTAL_URL = `https://${SLUG}.${DOMAIN}/portal-cidadao`
export const CITIZEN_PROFILE_URL = `https://${SLUG}.${DOMAIN}/perfil-cidadao`
export const SERVICES_LETTER_URL = `https://${SLUG}.${DOMAIN}/carta-de-servicos`
export const ACTIVITIES_URL = `https://${SLUG}.${DOMAIN}/atividades`
export const ATTENDANCE_URL =
  SLUG == 'agsus' ? `https://${SLUG}.${DOMAIN}/atendimento-colaborador` : `https://${SLUG}.${DOMAIN}/atendimentos`
export const DATA_INTEGRATOR_URL = `https://${SLUG}.${DOMAIN}/integrador-de-dados`
export const DIGITAL_ARCHIVE_URL = `https://${SLUG}.${DOMAIN}/acervo-digital`
export const REGULATION_URL = `https://${SLUG}.${DOMAIN}/regulacao`
export const SCHEDULES_URL = `https://${SLUG}.${DOMAIN}/agendas`
export const INVENTORY_URL = `https://${SLUG}.${DOMAIN}/estoque`
export const GEO_URL = `https://${SLUG}.${DOMAIN}/geo`
export const MESSENGER_URL = `https://${SLUG}.${DOMAIN}/mensageiro`
export const OBSERVATORY_URL = `https://${SLUG}.${DOMAIN}/observatorio`
export const SOCIAL_MANAGER_URL = `https://${SLUG}.${DOMAIN}/gestor-social`
export const ASSESSMENTS_AND_RESEARCH_URL = `https://${SLUG}.${DOMAIN}/avaliacoes-e-pesquisas`
export const CAREHUB_URL = `https://${SLUG}.${DOMAIN}/centro-de-cuidados`
export const PROCESSES_AND_DOCUMENTS_URL = `https://${SLUG}.${DOMAIN}/processos-e-documentos`
